import ApiClient from "../ApiClient";
import queryString from "query-string";

const RaffleApi = {
  getRaffle: async (cancelToken) => {
    const response = await ApiClient.get("raffleEvents/public/latest", {
      cancelToken,
    });
    return response.data.payload || {};
  },
  getRaffleEnrollment: async (cancelToken, sellerId) => {
    const response = await ApiClient.get(
      `raffleEnrollments/public${sellerId ? `/${sellerId}` : ""}`,
      { cancelToken },
    );
    return response.data.payload || {};
  },
  getRaffleWinners: async (cancelToken, chabadHouseId) => {
    const response = await ApiClient.get(
      `raffleEnrollments/public/winners${
        chabadHouseId ? `/${chabadHouseId}` : ""
      }`,
      { cancelToken },
    );
    return response.data.payload || [];
  },
  createOrder: async (cancelToken, order) => {
    const response = await ApiClient.post("raffleOrders", order, {
      cancelToken,
    });
    return response.data || {};
  },
  getSellers: async (cancelToken) => {
    const response = await ApiClient.get(
      "raffleEnrollments/public/sellerList",
      { cancelToken },
    );
    return response.data.payload || [];
  },
  getDonors: async (
    cancelToken,
    sellerId,
    page,
    results,
    sortByOption,
    searchText,
    teamId,
  ) => {
    const params = {
      page,
      results,
      sortByOption,
      text: searchText,
      teamId,
    };
    const response = await ApiClient.get(
      `raffleEnrollments/public/donations${
        sellerId ? `/${sellerId}` : ""
      }?${queryString.stringify(params)}`,
      { cancelToken },
    );
    return response.data.payload || {};
  },
  createTeam: async (cancelToken, team) => {
    const response = await ApiClient.post("raffleEnrollments/referrers", team, {
      cancelToken,
    });
    return response.data.payload;
  },
};

export default RaffleApi;
